import express from "express"

import { getList } from "../services/meals.js"

const router = express.Router()

router.get("/", async function (_req, res, next) {
	try {
		res.json(await getList())
	} catch (err) {
		console.error(`Error while getting meals `, err instanceof Error ? err.message : String(err))
		next(err)
	}
})

export default router
